if (!customElements.get("product-modal")) {
  customElements.define(
    "product-modal",
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.backButton = this.querySelector('[id^="BackButton-"]');
        this.nextButton = this.querySelector('[id^="NextButton-');

        if (this.nextButton) {
          this.nextButton.addEventListener("click", (ev) => {
            this.navigateMedia("next");
          });
        }

        if (this.backButton) {
          this.backButton.addEventListener("click", (ev) => {
            this.navigateMedia("previous");
          });
        }
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      /**
       * Compares an element to enable/disable buttons depending on if it has siblings or not
       * @param {HTMLElement} activeElement element to compare against
       */
      changeButtonState(activeElement) {
        if (this.nextButton) {
          this.nextButton.disabled = !activeElement.nextElementSibling;
        }
        if (this.backButton) {
          this.backButton.disabled = !activeElement.previousElementSibling;
        }
      }

      /**
       * Navigates back or forward between the available media elements
       * @param {("next" | "previous")} direction
       */
      navigateMedia(direction) {
        const oldActiveMedia = this.querySelector(".active");
        const activeMedia =
          direction === "next"
            ? oldActiveMedia.nextElementSibling
            : oldActiveMedia.previousElementSibling;

        if (!activeMedia) {
          return;
        }
        this.changeButtonState(activeMedia);
        this.changeActiveMedia(activeMedia.getAttribute("data-media-id"));
      }

      /**
       * Changes the current active media on the modal
       * @param {string} mediaId the id of the target media to set as active
       */
      changeActiveMedia(mediaId) {
        const oldActiveMedia = this.querySelector(".active");
        oldActiveMedia.classList.remove("active");
        const activeMedia = this.querySelector(`[data-media-id="${mediaId}"]`);

        const activeMediaTemplate = activeMedia.querySelector("template");
        const activeMediaContent = activeMediaTemplate
          ? activeMediaTemplate.content
          : null;
        activeMedia.classList.add("active");
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == "DEFERRED-MEDIA" &&
          activeMediaContent &&
          activeMediaContent.querySelector(".js-youtube")
        )
          activeMedia.loadContent();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute(
            "data-media-id"
          )}"])`
        ).forEach((element) => {
          element.classList.remove("active");
        });
        const activeMedia = this.querySelector(
          `[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`
        );
        this.changeButtonState(activeMedia);
        const activeMediaTemplate = activeMedia.querySelector("template");
        const activeMediaContent = activeMediaTemplate
          ? activeMediaTemplate.content
          : null;
        activeMedia.classList.add("active");
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == "DEFERRED-MEDIA" &&
          activeMediaContent &&
          activeMediaContent.querySelector(".js-youtube")
        )
          activeMedia.loadContent();
      }
    }
  );
}
